import Vue from 'vue';
import * as types from './types';

export const getters = {
};

export const mutations = {
  [types.TOUR_FINISHED]: (state, tourName) => {
    state.tourStates[tourName] = true;
    localStorage.setItem(tourName, true);
  },
  [types.ALL_TOURS_FINISHED]: (state) => {
    state.areAllToursFinished = true;
    localStorage.setItem('allToursFinished', true);
  },
  [types.CLEAR_TOUR_STATES]: (state) => {
    state.areAllToursFinished = false;
    localStorage.removeItem('allToursFinished');
    Object.keys(state.tourStates).forEach((tourStateName) => {
      state[tourStateName] = false;
      localStorage.removeItem(tourStateName);
    });
  },
  [types.GET_TOUR_STATE]: (state, tourName) => {
    Vue.set(state.tourStates, tourName, localStorage.getItem(tourName));
  },
};

export const state = {
  tourStates: {},
  areAllToursFinished: localStorage.getItem('allToursFinished'),
};
